var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"over"},[_vm._v("该场次预约已满")])}
var staticRenderFns = []

export { render, staticRenderFns }